exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./ClientApp/app/components/whitelabels/create-edit-whitelabel-modal/create-edit-whitelabel-modal.component.css
// module id = 694
// module chunks = 0